import { MessageDefinitionsScreen } from "./message-definitions.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { MessageDefinitionEditRoutes } from "../message-definition-edit";

export const MessageDefinitionsRoutes: RouteDefinition[] = [
	{
		path: Paths.messageDefinitions.path,
		element: <MessageDefinitionsScreen />,
		requiredPermissions: ["UserInAccountPermission_MessageDefinitionAdmin_Read"],
	},
	...MessageDefinitionEditRoutes,
];
